export default __webpack_public_path__ + "static/media/fully-connected.08d68212.png";